import React from 'react';
import PropTypes from 'prop-types';

import RavenUtil from 'APP_ROOT/components/common/ravenUtil';
import { strings } from 'APP_ROOT/localization';

const RECOMMENDED_MINIMUM_RADIUS_KM = 0.1;
const RECOMMENDED_MINIMUM_AREA_KM = 0.0314;

export default class ZoneSize extends React.Component {

    static propTypes = {
        radiusInKm: PropTypes.number,
        areaInKm2: PropTypes.number,
        radiusInKmStatus: PropTypes.string,
        unitOfMeasure: PropTypes.oneOf(['IMPERIAL','METRIC']).isRequired,
    }

    state = {
        moreInfoTooltipVisible: false
    }

    render () {

        let moreInfoTooltipClass = "more-info-tooltip";
        if (this.state.moreInfoTooltipVisible) {
            moreInfoTooltipClass += " visible";
        }

        const zoneSize = this.props.geofenceType === 'Polygon' ? RavenUtil.areaString(this.props.areaInKm2, this.props.unitOfMeasure, 5) : RavenUtil.distanceString(this.props.radiusInKm, this.props.unitOfMeasure, 3);
        const recommendedSize = this.props.geofenceType === 'Polygon' ?  RavenUtil.areaString(RECOMMENDED_MINIMUM_AREA_KM, this.props.unitOfMeasure, 5) : RavenUtil.distanceString(RECOMMENDED_MINIMUM_RADIUS_KM, this.props.unitOfMeasure, 3);
        const isBelowRecommendedSize = this.props.geofenceType === 'Polygon' ? this.props.areaInKm2 < RECOMMENDED_MINIMUM_AREA_KM : this.props.radiusInKm < RECOMMENDED_MINIMUM_RADIUS_KM;
        return (
            <section>
                <h4 className="label">{strings.resource_zone_size}</h4>
                <div className="value">
                        {zoneSize}
                        {isBelowRecommendedSize &&
                            <span
                                className="more-info"
                                onMouseEnter={() => {this.setState({moreInfoTooltipVisible: true})}}
                                onMouseLeave={() => {this.setState({moreInfoTooltipVisible: false})}}
                            >
                                <i className="material-icons">
                                    info
                                </i>
                                {strings.formatString(strings.geofence_minimum_size_warning, recommendedSize)}
                            </span>
                        }
                    </div>
                    <div className={moreInfoTooltipClass}>
                        {strings.formatString(strings.geofence_minimum_size_description, recommendedSize)}
                    </div>
            </section>
        )
    }
}
